import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { UploadComponent } from './upload/upload.component';
import { IdWrapperComponent } from './id-wrapper/id-wrapper.component';
import { SniffReportComponent } from './sniff-report/sniff-report.component';
import { PriorArtSearchComponent } from './prior-art-search/prior-art-search.component';
import { IndustryAnalysisComponent } from './industry-analysis/industry-analysis.component';
import { InfringementAnalysisComponent } from './infringement-analysis/infringement-analysis.component';
import { PostUploadComponent } from './post-upload/post-upload.component';
import { PromptManagementComponent } from './prompt-management/prompt-management.component';
import { TargetScoutingComponent } from './target-scouting/target-scouting.component';
import { InfringementSummaryComponent } from './infringement-summary/infringement-summary.component';
import { ReportsComponent } from './reports/reports.component';
import { HomeComponent } from './home-component/home.component';
import { ProjectReportsComponent } from './project-reports-component/project-reports.component';
import { AuthGuard } from './services/auth.guard';

export const routes: Routes = [
    
            // {
            //     path:'',
            //     redirectTo:'upload',
            //     pathMatch:'full'
            // },
            // {
            //     path:'upload',
            //     component:UploadComponent,
            // },
            // {
            //     path:'report',
            //     component:IdWrapperComponent
            // },
            {
                path:'app',
                component:IdWrapperComponent,
                children:[
                    {
                        path:'',
                        redirectTo:'upload',
                        pathMatch:'full',
                    },
                    {
                        path:'upload',
                        component:UploadComponent,
                        // make this the default route
                        pathMatch:'full',
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'report',
                        component:SniffReportComponent,
                    },
                    {
                        path:'pas',
                        component:PriorArtSearchComponent,
                        canActivate:[AuthGuard],
                        children:[
                            {
                                path:'report',
                                component:SniffReportComponent
                            }
                        ]
                    },
                    {
                        path:'target-scouting',
                        component:TargetScoutingComponent,
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'industry-analysis',
                        component:IndustryAnalysisComponent,
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'infringement-analysis',
                        component:InfringementAnalysisComponent,
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'infringement-summary',
                        component:InfringementSummaryComponent,
                        canActivate:[AuthGuard],
                        children:[
                            {
                                path:'report',
                                component:SniffReportComponent
                            }
                        ]
                    },
                    {
                        path:'post-upload',
                        component:PostUploadComponent,
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'reports',
                        component:ReportsComponent,
                        canActivate:[AuthGuard]
                    },
                    {
                        path:'prompt-management',
                        component:PromptManagementComponent,
                        canActivate:[AuthGuard],
                        pathMatch:'full'
                    },
                    {
                        path:'home',
                        component: HomeComponent,
                        canActivate:[AuthGuard],
                        pathMatch:'full'
                    },
                    {
                        path:'projects/:projectId/reports',
                        component: ProjectReportsComponent,
                        pathMatch:'full',
                        canActivate:[AuthGuard]
                    }
                ]
            },
            {
                path:'',
                redirectTo:'app/home',
                pathMatch:'full'
            }
];
